module.exports = __webpack_public_path__ + "img/favorisMercuriale.9da3541e.png";